module.exports = __webpack_public_path__ + "media/images/web_suite/vb_suite_logo_transparent-f9fce05e5a55f24d81dbc7aca0ce36c9.png";